import React from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap-5';

export default class ImportCalendarModal extends React.Component {

  static propTypes = {
    calendars: PropTypes.array,
    currentDatabase: PropTypes.object,
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  state = {
    calendar: null
  }

  calendarIsSelected = (id) => {
    const { calendar } = this.state;

    if (!calendar || !calendar.id) {
      return false;
    }

    return calendar.id === id;
  }


  handleCalendarSelect = (e) => {
    const { calendars } = this.props;

    const id = e.target.value;
    const calendar = calendars.find(cal => cal.id == id);
    this.setState({ calendar });
  }

  renderCalendarOptions() {
    const { calendars } = this.props;
    return (calendars || []).map(calendar => (
      <Form.Check
        checked={this.calendarIsSelected(calendar.id)}
        className="mb-2"
        id={`calendar-${calendar.id}`}
        key={calendar.id}
        label={calendar.name}
        name="calendar"
        type="radio"
        value={calendar.id}
        onChange={this.handleCalendarSelect}
      />
    ));
  }

  render() {
    const {
      currentDatabase,
      shown,
      onCancel,
      onSave
    } = this.props;

    const { calendar } = this.state;
    const calendarSelected = Boolean(calendar && calendar.id);

    return (
      <Modal centered show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Import Calendar Events</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column mb-2">
          <div>
            Choose which calendar you would like to sync with <strong>"{currentDatabase.name}"</strong>
          </div>
          <Form>{this.renderCalendarOptions()}</Form>
          <div className="text-muted">Buildout will import all future and recurring events.</div>
        </Modal.Body>
        <Modal.Footer className="border-top text-end">
          <Button variant="ghost" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            disabled={!calendarSelected}
            variant="primary"
            onClick={() => calendarSelected ? onSave(calendar) : null}
          >
            Import & Sync
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
